import { rtlDataAttribute } from '../../config/script-attributes'
import { NavConfig } from './configs/base'
import * as nav from './nav-core'

export function generateNav(
	navStyles: string,
	navDefaultVariant: string,
	myAccountFallbackImage: string,
	footerDefaultVariant: string,
	config?: NavConfig,
	gbpeInitializationFunction?: (config: NavConfig) => void,
	handleLanguageLinksPath?: boolean
): void {
	document.dir = rtlDataAttribute === 'true' ? 'rtl' : config?.direction || 'ltr'
	gbpeInitializationFunction?.call(null, config)

	@nav.component('gb-global-nav')
	class Nav extends nav.GlobalNav {
		constructor() {
			super(navStyles, navDefaultVariant, config, handleLanguageLinksPath)
		}
	}

	@nav.component('gb-myaccount-nav')
	class MyAccNav extends nav.GbpeMyaccount {
		constructor() {
			super()
		}
	}

	@nav.component('gb-myaccount-flyout')
	class MyAccFlyout extends nav.GbpeMyaccountFlyout {
		constructor() {
			super(myAccountFallbackImage, config)
		}
	}

	@nav.component('gb-global-footer')
	class Footer extends nav.GbpeFooter {
		constructor() {
			super(navStyles, footerDefaultVariant)
		}
	}
}
